import { loadPresets } from 'presets/sources/loadPresets';
import { useQuery } from 'query';

import { screenPresets } from './queryKeyFactory';

export const useLoadPresets = (screenKey: string) => {
  return useQuery(screenPresets(screenKey), async () => {
    return loadPresets({ key: screenKey });
  });
};
